import { render } from "./KefuModel.vue?vue&type=template&id=7fe2a376"
import script from "./KefuModel.vue?vue&type=script&lang=js"
export * from "./KefuModel.vue?vue&type=script&lang=js"

import exportComponent from "G:\\VUE\\waimao518_3.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__